import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { SelectedApexMech } from '@ortho-next/nextray-core';
import { BoneTypeEnum } from '../../core';
import { BaseComponent } from '../../shared';


/**
* Component of first vertical sidebar to select osteotomy site.
*/
@Component({
	selector: 'osteotomy-workflow',
	templateUrl: './osteotomy-workflow.component.html',
	imports: [
		FormsModule
	],
	changeDetection: ChangeDetectionStrategy.Eager
})
export class OsteotomyWorkflowComponent extends BaseComponent implements OnInit {

	site?: ApexSiteEnum;
	apexSiteEnum = ApexSiteEnum;

	ngOnInit(): void {
		this.site = this.apexSite();
	}

	get isLongLegVisible(): boolean {
		return this.hasLT ? this.boneTypeLT === BoneTypeEnum.LongLeg : this.isLongLeg;
	}
	get isFemurVisible(): boolean {
		return this.hasLT ? this.boneTypeLT === BoneTypeEnum.Femur : this.isFemur;
	}
	get isTibiaVisible(): boolean {
		return this.hasLT ? this.boneTypeLT === BoneTypeEnum.Tibia : this.isTibia;
	}

	/**
	 * Get apex site label.
	 */
	apexSiteLabel(apexSite?: ApexSiteEnum): string | undefined {
		switch (apexSite) {
			case ApexSiteEnum.ProximalFemur: return this.labels().APEX_SITE_PROXIMAL_FEMUR;
			case ApexSiteEnum.DistalFemur: return this.labels().APEX_SITE_DISTAL_FEMUR;
			case ApexSiteEnum.ProximalTibia: return this.labels().APEX_SITE_PROXIMAL_TIBIA;
			case ApexSiteEnum.DistalTibia: return this.labels().APEX_SITE_DISTAL_TIBIA;
			default: return apexSite;
		}
	}

	/**
	* Close osteotomy site selection workflow.
	*/
	back(): void {
		this.canvasSrv.dispatch('cancelSelectingApex');
	}

	/**
	* Confirm osteotomy site selection and place osteotomy line.
	*/
	confirm(): void {
		this.confirmApexSite();
		this.placeOsteotomy();
	}

	private confirmApexSite(): void {
		const event = this.selectedApexEvent();
		if (event) this.canvasSrv.dispatch(event);
	}

	private placeOsteotomy(): void {
		this.canvasSrv.dispatch('place-osteotomy');
	}

	private apexSite(): ApexSiteEnum | undefined {
		switch (this.selectedApex) {
			case SelectedApexMech.femurProximal: return ApexSiteEnum.ProximalFemur;
			case SelectedApexMech.femurDistal: return ApexSiteEnum.DistalFemur;
			case SelectedApexMech.tibiaProximal: return ApexSiteEnum.ProximalTibia;
			case SelectedApexMech.tibiaDistal: return ApexSiteEnum.DistalTibia;
			default: return undefined;
		}
	}

	private selectedApexEvent(): 'apexFemurProximal' | 'apexFemurDistal' | 'apexTibiaProximal' | 'apexTibiaDistal' | null {
		switch (this.site) {
			case ApexSiteEnum.ProximalFemur: return 'apexFemurProximal';
			case ApexSiteEnum.DistalFemur: return 'apexFemurDistal';
			case ApexSiteEnum.ProximalTibia: return 'apexTibiaProximal';
			case ApexSiteEnum.DistalTibia: return 'apexTibiaDistal';
			default: return null;
		}
	}

}


export enum ApexSiteEnum {
	ProximalFemur = 'Proximal Femur',
	DistalFemur = 'Distal Femur',
	ProximalTibia = 'Proximal Tibia',
	DistalTibia = 'Distal Tibia'
}
